/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { SkipNav } from "components/SkipNav";
import { shouldFetchAccContent, isAccEnabledByDefault } from "selectors/accessibilitySelectors";

const mapStoreToProps = (stores, ownProps) => {
  const enableAccString = ownProps.intl.formatMessage({ id: "accessibility.enable" });
  const enabledAccString = ownProps.intl.formatMessage({ id: "accessibility.enabled" });
  return {
    shouldFetchAccContent: shouldFetchAccContent(stores),
    isAccEnabledByDefault: isAccEnabledByDefault(stores),
    enableScreenReader: evt => {
      if (shouldFetchAccContent(stores)) {
        evt.preventDefault();
        evt.stopPropagation();
      } else {
        evt.currentTarget.value = enabledAccString;
        evt.currentTarget.nextSibling.innerText = enabledAccString;
        stores.accessibilityStore.setShouldFetchAccContent();
      }
    },
    enableAccString,
    enabledAccString
  };
};

const SkipNavContainer = inject(mapStoreToProps)(SkipNav);
export { SkipNavContainer };
